import { IAppConstants } from '../../app.constants';
import { IPromise, IHttpResponse, IQService } from 'angular';

export const HttpResponseErrorInterceptor: Function = ($injector: any, $q: IQService, $timeout: ng.ITimeoutService, $rootScope: any, configuration: any, store: ng.a0.storage.IStoreService) => {
    return {
        'request': (config) => {

            if (config.url.includes("googleapis.com")){
                return config;
            }

            if (store.get('jwt')) {
                config.headers.authorization = 'Bearer ' + store.get('jwt');
            } else if (store.get('registrationJWT')) {
                config.headers.authorization = 'Bearer ' + store.get('registrationJWT');
            }
            return config;
        },
        'responseError': (response) => {

            // for now we retry statuses  0 and -1, the rest we reject. In future more statuses may be included..
            if (response.status === 0 || response.status === -1) {
                return $timeout(() => {
                    let $http = $injector.get('$http');

                    let requestUrl = response.config.url.split('?')[0];

                    if (requestUrl in $rootScope.WSRequestsCounter) {
                        $rootScope.WSRequestsCounter[requestUrl]++;
                        if ($rootScope.WSRequestsCounter[requestUrl] > configuration.WSAutoRetryRequestsNumber - 1) {
                            let $uibModal = $injector.get('$uibModal');

                            $rootScope.loading = false;

                            let retryWSModalInstance = $uibModal.open({
                                animation: true,
                                component: 'retryWSModalComponent',
                                size: 'md',
                                windowClass: 'center-modal',
                                backdrop: 'static',
                                keyboard: false,
                                resolve: {
                                    settings: () => {
                                        let settings = {
                                            httpConfig: response.config,
                                            attempts: $rootScope.WSRequestsCounter[requestUrl]
                                        };
                                        return settings;
                                    }
                                }
                            });

                            return retryWSModalInstance.result.then((retry) => {
                                if (retry !== undefined && retry) {
                                    return $http(response.config);
                                } else {
                                    $rootScope.WSRequestsCounter[requestUrl] = 0;
                                    return; // $q.reject(response);
                                }
                            });

                        } else {
                            return $http(response.config);
                        }
                    } else {
                        $rootScope.WSRequestsCounter[requestUrl] = 0;
                        return $http(response.config);
                    }


                }, configuration.WSRetryRequestsDelay);
            } else {
                return $q.reject(response);
            }
        },
        'response': (response) => {
            let requestUrl = response.config.url.split('?')[0];
            if (requestUrl in $rootScope.WSRequestsCounter) {
                $rootScope.WSRequestsCounter[requestUrl] = 0;
            }
            if (response.config.url === 'folder.html') {
                return response;
            }
            return $q.resolve(response.config.url.indexOf('uib') !== -1 ? response : response.data);
        }
    };
};

HttpResponseErrorInterceptor.$inject = ['$injector', '$q', '$timeout', '$rootScope', 'configuration', 'store'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/http-response-error-interceptor/http-response-error-interceptor.service.ts